import React, { FC } from 'react';
import { StyleSheet, Text, View } from 'react-native';

import { font } from '@styles/fonts';

import {
  ParsedValidationWarning,
  ValidationErrorsPopupProps,
} from '@components/settings/v2/structure/connector/productionConnectorSetup/components/ValidationErrorsPopup/types';
import { scale } from '@components/frame';
import { insertPathBreakOpportunities } from '@helpers';

interface ValidationWarningItemProps extends Pick<ValidationErrorsPopupProps, 'C'> {
  warning: ParsedValidationWarning;
}

const ValidationWarningItem: FC<ValidationWarningItemProps> = ({ warning, C }) => {
  const wrappablePath = insertPathBreakOpportunities(warning.folderPath);

  return (
    <View style={styles.warningCard}>
      <View style={styles.warningHeader}>
        {warning.folderName && (
          <View style={styles.folderNameBadge}>
            <Text style={[font['Button 3'], { color: C('Label/Light/Primary') }]}>{warning.folderName}</Text>
          </View>
        )}
        <Text style={[font.Footnote, styles.folderPath, { color: C('Label/Light/Primary') }]}>{wrappablePath}</Text>
      </View>
      <Text style={[font.Footnote, { color: C('Label/Light/Tertiary') }]}>{warning.message}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  list: { gap: scale(6) },
  headlineMargin: { marginBottom: scale(10) },
  warningCard: {
    backgroundColor: 'rgba(255, 204, 0, 0.1)',
    borderColor: 'rgba(255, 204, 0, 0.5)',
    borderWidth: StyleSheet.hairlineWidth,
    paddingVertical: scale(10),
    paddingHorizontal: scale(12),
    borderRadius: scale(8),
    gap: scale(3),
  },
  warningHeader: { flexDirection: 'row', gap: scale(6), alignItems: 'center' },
  folderPath: { flex: 1 },
  folderNameBadge: {
    backgroundColor: 'rgba(255, 204, 0, 0.5)',
    paddingVertical: scale(1),
    paddingHorizontal: scale(6),
    borderRadius: scale(4),
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default ValidationWarningItem;
